import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { CONGVIEC } from '../constants';
import { Get, Post, Put, DeleteSingle } from '../../utils/httpProvider';
import { CONGVIEC_API } from '../../utils/apiUrl';

export const congViecGetByProjectStepAction = createAsyncThunk(
    CONGVIEC.GET_BY_PROJECT_STEP,
    async (projectStepId, { rejectWithValue }) => {
        try {
            const data = await Get(
                CONGVIEC_API.GET_BY_PROJECT_STEP(projectStepId),
                null,
                null
            );
            if (!data) {
                return rejectWithValue('Không lấy được danh sách công việc');
            }
            return data;
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);

export const congViecCreateAction = createAsyncThunk(
    CONGVIEC.CREATE,
    async (model, { rejectWithValue }) => {
        try {
            const res = await Post(CONGVIEC_API.CREATE, null, model, false);

            if (res && typeof res.status === 'number') {
                if (res.status >= 200 && res.status < 300) {
                    let body = null;
                    try {
                        body = await res.json();
                    } catch (_) {}
                    return body || model;
                }

                let errBody = null;
                try {
                    errBody = await res.json();
                } catch (_) {}
                return rejectWithValue(
                    errBody || 'Tạo công việc thất bại'
                );
            }

            if (!res) return rejectWithValue('Tạo công việc thất bại');

            return res;
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);

export const congViecUpdateAction = createAsyncThunk(
    CONGVIEC.UPDATE,
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const res = await Put(CONGVIEC_API.UPDATE(id), null, data);
            if (res && typeof res.status === 'number') {
                if (res.status >= 200 && res.status < 300) {
                    let body = null;
                    try {
                        body = await res.json();
                    } catch (_) {}
                    return body || { id, ...data };
                }

                let errBody = null;
                try {
                    errBody = await res.json();
                } catch (_) {}
                return rejectWithValue(
                    errBody || 'Cập nhật công việc thất bại'
                );
            }

            if (!res) return rejectWithValue('Cập nhật công việc thất bại');

            return res;
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);

export const congViecDeleteAction = createAsyncThunk(
    CONGVIEC.DELETE,
    async (id, { rejectWithValue }) => {
        try {
            const res = await DeleteSingle(
                CONGVIEC_API.DELETE(id),
                null
            );
            if (res && typeof res.status === 'number') {
                if (res.status === 200 || res.status === 204) {
                    return id;
                }

                let errBody = null;
                try {
                    errBody = await res.json();
                } catch (_) {}
                return rejectWithValue(
                    errBody || 'Xoá công việc thất bại'
                );
            }

            if (!res) return rejectWithValue('Xoá công việc thất bại');

            return res;
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);

const initialState = {
    items: [],
    loading: false,
    error: null,
};

export const congViecSlice = createSlice({
    name: CONGVIEC.NAME_SLICE,
    initialState,
    reducers: {
        clearCongViec(state) {
            state.items = [];
            state.loading = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(congViecGetByProjectStepAction.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(congViecGetByProjectStepAction.fulfilled, (state, action) => {
                state.loading = false;
                state.items = action.payload || [];
            })
            .addCase(congViecGetByProjectStepAction.rejected, (state, action) => {
                state.loading = false;
                state.error =
                    action.payload ||
                    action.error?.message ||
                    'Lỗi khi tải danh sách công việc';
            })

            .addCase(congViecCreateAction.fulfilled, (state, action) => {
                if (action.payload) {
                    state.items.push(action.payload);
                }
            })
            .addCase(congViecCreateAction.rejected, (state, action) => {
                state.error =
                    action.payload ||
                    action.error?.message ||
                    'Tạo công việc thất bại';
            })

            .addCase(congViecUpdateAction.fulfilled, (state, action) => {
                const updated = action.payload;
                if (!updated || !updated.id) return;

                const idx = state.items.findIndex((x) => x.id === updated.id);
                if (idx >= 0) {
                    state.items[idx] = { ...state.items[idx], ...updated };
                }
            })
            .addCase(congViecUpdateAction.rejected, (state, action) => {
                state.error =
                    action.payload ||
                    action.error?.message ||
                    'Cập nhật công việc thất bại';
            })

            .addCase(congViecDeleteAction.fulfilled, (state, action) => {
                const id = action.payload;
                state.items = state.items.filter((x) => x.id !== id);
            })
            .addCase(congViecDeleteAction.rejected, (state, action) => {
                state.error =
                    action.payload ||
                    action.error?.message ||
                    'Xoá công việc thất bại';
            });
    },
});

export const { clearCongViec } = congViecSlice.actions;
export default congViecSlice.reducer;
